/** Drawing shortcuts must never consume keyboard interaction in the UI. */
export function isUiEvent(event) {
  return !!event.target?.closest?.('input, select, textarea, button, a, summary, [contenteditable="true"], [role="tab"], [role="menu"], [role="button"], [role="slider"]');
}
